<template>
  <basic-container>
    <div>
      <el-tabs v-model="activeSource" @tab-click="tabClick">
        <el-tab-pane label="弹窗" :name="2" />
        <el-tab-pane label="banner" :name="3" />
        <el-tab-pane label="icon" :name="4" />
      </el-tabs>
    </div>
    <div class="search-contain">
      <el-form ref="query" :model="query" :inline="true" size="mini">
        <el-form-item :label="activeSource === 4 ? 'icon名称' : '广告名称'">
          <el-input placeholder="请输入名称" v-model="query.name" clearable />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="query.status" placeholder="请选择" clearable filterable>
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="活动时间" prop="daterange">
          <el-date-picker
            v-model="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item
          v-if="activeSource === 3 || activeSource === 4"
          :label="activeSource === 4 ? '排序' : '权重'"
          prop="sort"
        >
          <el-select v-model="query.sort" placeholder="请选择" clearable>
            <el-option
              v-for="item in sortList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="activeSource === 4 ? '位置' : '广告位置'" prop="locationKey">
          <el-select v-model="query.locationKey" placeholder="请选择" clearable filterable>
            <el-option
              v-for="item in locationList"
              :key="item.advertisingLocationKey"
              :label="item.advertisingLocationDesc"
              :value="item.advertisingLocationKey"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创建人">
          <el-input placeholder="请输入" v-model="query.createUser" clearable />
        </el-form-item>
        <el-form-item label="地区" v-if="activeSource === 3 || activeSource === 4">
          <YdCitySelect
            mode="1"
            placeholder="请选择地级归属"
            :customHttp="getDriverAreaTree"
            :fieldFormat="fieldFormat"
            v-model="query.locationId"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="searchChange"
            >筛选</el-button
          >
          <el-button type="danger" icon="el-icon-delete" :loading="loading" @click="searchReset"
            >清空</el-button
          >
          <!--          <el-button-->
          <!--            class="add"-->
          <!--            type="primary"-->
          <!--            @click="addClick"-->
          <!--            icon="el-icon-plus"-->
          <!--            style="margin-right: 40px"-->
          <!--            v-has-permi="['user_advertising_edit']"-->
          <!--            >新增</el-button-->
          <!--          >-->
        </el-form-item>
      </el-form>
    </div>
    <div>
      <!--      <el-button-->
      <!--        class="layoutConfig"-->
      <!--        @click="addConfig"-->
      <!--        style="margin-right: 40px"-->
      <!--        v-has-permi="['usr_layout_configuration']"-->
      <!--        v-if="activeSource === 4"-->
      <!--        >布局配置</el-button-->
      <!--      >-->
    </div>
    <yd-table
      ref="advertisingTable"
      :data="records"
      :pagination="pagination"
      :loading="loading"
      @onChange="onTableChange"
    >
      <el-table-column
        :label="activeSource === 4 ? 'icon名称' : '广告名称'"
        prop="name"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="openDetail(scope.row)">{{ scope.row.name }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        :label="activeSource === 4 ? '位置' : '广告位置'"
        prop="locationDesc"
        align="center"
        width="150"
      />
      <el-table-column
        :label="activeSource === 4 ? '排序' : '权重'"
        prop="sort"
        align="center"
        key="sort"
        width="80"
      />
      <el-table-column label="图片" prop="imgUrl" align="center">
        <template slot-scope="scope">
          <el-image
            v-if="activeSource === 4 || activeSource === 2"
            style="width: 40px; height: 40px"
            :src="scope.row.imgUrl"
            :preview-src-list="[scope.row.imgUrl]"
          />
          <el-image
            v-else
            style="width: 50px; height: 40px"
            :src="scope.row.imgUrl"
            :preview-src-list="[scope.row.imgUrl]"
          />
        </template>
      </el-table-column>
      <el-table-column label="展示渠道" prop="displayChannel" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.displayChannel || '-' }}</div>
        </template>
      </el-table-column>
      <!--      <el-table-column label="展示地区" prop="location" align="center" />-->
      <el-table-column label="开始时间" prop="startTime" align="center" />
      <el-table-column label="结束时间" prop="endTime" align="center" />
      <el-table-column
        v-if="activeSource === 4"
        label="状态"
        prop="statusStr"
        align="center"
        width="100"
      />
      <el-table-column label="操作" prop="operate" align="center" width="180">
        <template slot-scope="scope">
          <!--          <el-button-->
          <!--              type="text"-->
          <!--              @click="getAdvertisingInfo(scope.row.id)"-->
          <!--              v-if="scope.row.status !== 4 || activeSource === 4"-->
          <!--              size="mini"-->
          <!--              v-has-permi="['user_advertising_edit']"-->
          <!--          >编辑-->
          <!--          </el-button-->
          <!--          >-->
          <!--          <el-button-->
          <!--              type="text"-->
          <!--              @click="handleStart(scope.row)"-->
          <!--              size="mini"-->
          <!--              v-if="scope.row.status == 5 && activeSource !== 4"-->
          <!--              v-has-permi="['user_advertising_status']"-->
          <!--          >上架-->
          <!--          </el-button-->
          <!--          >-->
          <!--          <el-button-->
          <!--              type="text"-->
          <!--              @click="handleApprove(scope.row.id)"-->
          <!--              v-if="scope.row.status == 1 && activeSource !== 4"-->
          <!--              size="mini"-->
          <!--              v-has-permi="['user_advertising_review']"-->
          <!--          >通过-->
          <!--          </el-button-->
          <!--          >-->
          <!--          <el-button-->
          <!--              type="text"-->
          <!--              @click="handleFailed(scope.row.id)"-->
          <!--              v-if="scope.row.status == 1 && activeSource !== 4"-->
          <!--              size="mini"-->
          <!--              v-has-permi="['user_advertising_review']"-->
          <!--          >不通过-->
          <!--          </el-button-->
          <!--          >-->
          <!--          <el-button-->
          <!--              type="text"-->
          <!--              v-if="scope.row.status == 4 && activeSource !== 4"-->
          <!--              @click="handleFinish(scope.row.id)"-->
          <!--              size="mini"-->
          <!--              v-has-permi="['user_advertising_status']"-->
          <!--          >下架-->
          <!--          </el-button-->
          <!--          >-->
          <el-button
            type="text"
            @click="dataView(scope.row)"
            v-if="scope.row.status > 3"
            size="mini"
            v-has-permi="['user_advertising_data']"
            >数据
          </el-button>
          <!--          <el-button-->
          <!--              v-if="activeSource === 4"-->
          <!--              type="text"-->
          <!--              size="mini"-->
          <!--              @click="moveUp(scope.row, scope.$index)"-->
          <!--              :disabled="scope.$index === 0"-->
          <!--          >上移-->
          <!--          </el-button-->
          <!--          >-->
          <!--          <el-button-->
          <!--              v-if="activeSource === 4"-->
          <!--              type="text"-->
          <!--              size="mini"-->
          <!--              @click="moveDown(scope.row, scope.$index)"-->
          <!--              :disabled="getFormLength(scope.$index)"-->
          <!--          >下移-->
          <!--          </el-button-->
          <!--          >-->
        </template>
      </el-table-column>
    </yd-table>
    <advertising-edit
      v-if="editVisible"
      :visible="editVisible"
      :title="title"
      :locationList="locationList"
      :type="activeSource"
      :clientType="clientType"
      @saveEdit="saveEdit"
      @closeEdit="closeEdit"
      :advertisingInfo="advertisingInfo"
    />
    <data-view ref="dataView" />
    <advertising-detail ref="advertisingDetail" />
    <YDCommonDialog :show.sync="dialog.show" v-bind="dialog" @submit="dialog.onSubmit">
      <component
        v-if="dialog.show"
        :is="dialog.tag"
        v-bind="dialog"
        :loading="dialog.loading"
        ref="panel"
        title=""
        v-model="dialog.modelData"
      />
    </YDCommonDialog>
  </basic-container>
</template>

<script>
  import {
    getAdvertisingPage,
    saveOrUpdate,
    getInfo,
    changeStatus,
    advertisingLocation,
    iconUpdateSort,
    advertisingList
  } from '@/api/marketing/advertising'
  import AdvertisingEdit from './components/advertising-edit-old.vue'
  import AdvertisingDetail from './components/advertising-detail'
  import DataView from './components/data-view'
  import { mapState } from 'vuex'
  import dayjs from 'dayjs'
  import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
  import { getDriverAreaTree } from '@/api/vehicle/vehicle-manage'
  import iconLayout from './components/iconLayout.vue'

  export default {
    components: {
      AdvertisingEdit,
      DataView,
      AdvertisingDetail,
      iconLayout
    },
    data() {
      return {
        getDriverAreaTree,
        statusList: [
          { value: 1, label: '待审核' },
          { value: 2, label: '审核未通过' },
          { value: 3, label: '未开始' },
          { value: 4, label: '进行中' },
          { value: 5, label: '已下架' }
        ],
        locationKeyList: [],
        sortList: [
          { value: 1 },
          { value: 2 },
          { value: 3 },
          { value: 4 },
          { value: 5 },
          { value: 6 },
          { value: 7 },
          { value: 8 },
          { value: 9 },
          { value: 10 }
        ],
        activeSource: 2,
        query: {},
        daterange: [],
        // 分页
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10
        },
        records: [],
        title: '新增',
        clientType: 1,
        editVisible: false,
        advertisingInfo: {},
        dataVisible: false,
        loading: false,
        dialog: {
          show: false,
          tag: 'editChannelCode',
          loading: false,
          onSubmit: () => {}
        },
        iconConfig: {
          layoutType: '2'
        }
      }
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.user.userInfo
      }),
      locationList() {
        const list = this.locationKeyList
        // if(this.clientType === 1){
        return list.filter((item) => item.advertisingLocationKey.search('client') !== -1)
        // }
        // return list
      }
    },
    created() {
      dayjs.extend(isSameOrAfter)
      const { activeSource } = this.$route.query || {}
      this.activeSource = activeSource ? Number(activeSource) : 2
    },
    mounted() {
      this.initPage()
      this.getAdvertisingLocation()
    },
    methods: {
      // 控制下移按钮的显示于隐藏
      getFormLength(index) {
        if (index === this.records.length - 1) return true
        else return false
      },
      async moveUpdateSort(params) {
        await iconUpdateSort(params)
      },
      // 上移
      moveUp(item, index) {
        this.records.splice(index - 1, 0, item) // 定位到点击位置的上一行，0即不删除如何元素，在此位置插入item
        this.records.splice(index + 1, 1) // 此时数组中有重复元素，把原来被挤下去的元素删除
        this.records.forEach((item, index) => {
          item.sort = index + 1
        })
        // const params = {
        //   id: item.id,
        //   sort: item.sort - 1
        // }
        this.moveUpdateSort(this.records) // 更新数组对象到后端
      },
      // 下移
      moveDown(item, index) {
        this.records.splice(index + 2, 0, item)
        this.records.splice(index, 1)
        this.records.forEach((item, index) => {
          item.sort = index + 1
        })
        // const params = {
        //   id: item.id,
        //   sort: item.sort + 1
        // }
        this.moveUpdateSort(this.records) // 更新数组对象到后端
      },
      initPage() {
        let startTime = ''
        let endTime = ''
        if (this.daterange && this.daterange.length !== 0) {
          startTime = this.daterange[0]
          endTime = this.daterange[1]
        }
        const params = {
          startTime,
          endTime,
          ...this.pagination,
          size: this.pagination.pageSize,
          ...this.query,
          clientType: this.clientType,
          type: this.activeSource
        }
        this.getAdvertisingPageFetch(params)
      },
      addClick() {
        if (this.activeSource === 2) {
          this.title = '新增弹窗'
        } else {
          this.title = '新增banner'
        }
        this.editVisible = true
      },
      saveEdit(form) {
        const params = {
          ...form,
          clientType: this.clientType,
          type: this.activeSource
        }
        this.handleSaveOrUpdate(params)
      },
      closeEdit() {
        this.advertisingInfo = {}
        this.editVisible = false
      },
      // 获取选择内容
      searchChange() {
        this.pagination = {
          current: 1,
          pageSize: 10
        }
        this.initPage()
      },
      searchReset() {
        this.daterange = []
        this.query = {}
        this.pagination = {
          current: 1,
          pageSize: 10
        }
        this.initPage()
      },
      handleSaveOrUpdate(params) {
        this.$loading()
        saveOrUpdate(params)
          .then((res) => {
            const { code } = res
            if (code === 0) {
              this.$message.success('保存成功！')
              this.advertisingInfo = {}
              this.editVisible = false
              this.initPage()
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      handleApprove(id) {
        this.$confirm('确定通过审核吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '稍后再看',
          type: 'warning',
          center: true
        })
          .then(() => {
            const params = {
              id,
              status: 999,
              updateUser: this.userInfo.userId
            }
            this.handleChangeStatus(params)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      handleFailed(id) {
        this.$prompt('确定审核不通过吗？', '提示', {
          inputPlaceholder: '请输入不通过原因',
          inputErrorMessage: '请输入不通过原因',
          cancelButtonText: '稍后再看',
          confirmButtonText: '确定',
          inputType: 'textarea',
          inputValidator: (value) => {
            // 带有监听功能监听输入value值 触发return false时输入框会提示inputErrorMessage的内容
            if (!value) {
              return '原因不能为空'
            }
          },
          type: 'warning'
        })
          .then((e) => {
            const params = {
              id,
              status: 2,
              updateUser: this.userInfo.userId,
              refuseReason: e.value
            }
            this.handleChangeStatus(params)
          })
          .catch(() => {
            this.$message({ type: 'info', message: '输入错误或已取消' })
          })
      },
      handleStart(obj) {
        const time = new Date()
        const timeInfo = dayjs(time).format('YYYY-MM-DD HH:mm:ss')
        const isSameOrAfter = dayjs(timeInfo).isSameOrAfter(dayjs(obj.endTime), 'day')
        if (isSameOrAfter) {
          this.$message.error('该活动已超过有效期，无法上架！')
          return
        }
        this.$confirm('', '确定上架吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '稍后再看',
          type: 'warning',
          center: true
        })
          .then(() => {
            const params = {
              id: obj.id,
              status: 998,
              updateUser: this.userInfo.userId
            }
            this.handleChangeStatus(params)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      handleFinish(id) {
        this.$confirm('下架后不再展示该活动！', '确定下架吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '稍后再看',
          type: 'warning',
          center: true
        })
          .then(() => {
            const params = {
              id,
              status: 5,
              updateUser: this.userInfo.userId
            }
            this.handleChangeStatus(params)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      handleChangeStatus(params) {
        this.$loading()
        changeStatus(params)
          .then((res) => {
            const { code } = res
            if (code === 0) {
              this.$message.success('操作成功！')
              this.initPage()
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      dataView(obj) {
        this.$refs.dataView.init(obj.id, obj.name)
      },
      openDetail(obj) {
        this.$refs.advertisingDetail.init(obj.id)
      },
      // 获取广告位分页
      async getAdvertisingPageFetch(params) {
        this.loading = true
        if (this.activeSource !== 4) {
          const { code, data } = await getAdvertisingPage(params)
          this.loading = false
          if (code === 0) {
            const { records = [], total = 0, size = 10, current = 1 } = data || {}
            this.records = records
            this.pagination = {
              ...this.pagination,
              total,
              current,
              pageSize: size
            }
          }
        } else {
          const { code, data } = await advertisingList(params)
          this.loading = false

          if (code === 0) {
            this.records = data
            this.pagination.total = 0
          }
          /* if (code === 0) {
            const { records = [], total = 0, size = 10, current = 1 } = data || {}
            this.records = records
            this.pagination = {
              ...this.pagination,
              total,
              current,
              pageSize: size
            }
          } */
        }
        setTimeout(() => {
          if (this.$refs.advertisingTable && this.$refs.advertisingTable.doLayout) {
            this.$refs.advertisingTable.doLayout()
          }
        }, 100)
      },
      getAdvertisingInfo(id) {
        this.$loading()
        getInfo(id)
          .then((res) => {
            const { data, code } = res
            if (code === 0) {
              this.advertisingInfo = data
              this.editVisible = true
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      getAdvertisingLocation() {
        advertisingLocation().then((res) => {
          const { data, code } = res
          if (code === 0) {
            this.locationKeyList = data
          }
        })
      },
      onTableChange({ current, pageSize }) {
        // 分页改变后的逻辑
        this.pagination.pageSize = pageSize
        this.pagination.current = current
        this.initPage()
      },
      tabClick() {
        this.query = {}
        this.records = []
        this.pagination = {
          total: 0,
          current: 1,
          pageSize: 10
        }
        this.initPage()
      },
      fieldFormat(data) {
        data.forEach((item) => {
          item.children &&
            item.children.forEach((child) => {
              child.children = null
            })
        })
        const search = (list) => {
          for (let i = 0; i < list.length; i++) {
            const { children } = list[i]
            if (Array.isArray(children) && children.length > 0) {
              list[i].childAreaManage = children
              search(children)
            }
          }
        }

        search(data)

        return data
      },
      addConfig() {
        Object.assign(this.dialog, {
          title: '调整icon布局',
          show: true,
          tag: 'iconLayout',
          cancelText: '取消',
          submitText: '确定',
          width: '800px',
          loading: false,
          editData: {},
          modelData: this.iconConfig,
          onSubmit: () => {
            this.$confirm('乘客端将立即生效，是否确认更改布局?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {})
              .catch(() => {})
          },
          beforeClose: (done) => {
            done && done()
            this.dialog.show = false
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .layoutConfig {
    background-color: #30b8a6 !important;
    color: #ffffff;
    border: none;
  }
</style>
